var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { ACCOUNT, CART, MENU_ITEMS, MENU_OPTION_EXCEPTIONS } from '@/stores/defs';
import { forEach, map, flatten, includes, find, findIndex, filter, reduce, } from 'lodash';
import cartService from '@/services/cart.service';
var offersMixin = {
    computed: __assign({}, mapGetters({
        getOffers: ACCOUNT.GET_OFFERS,
        getCustomer: ACCOUNT.GET_CUSTOMER,
        cartItems: CART.NON_BUNDLE_ITEMS,
        allCartItems: CART.ITEMS,
        menuItems: MENU_ITEMS.GET_MAP,
        getApplyOffer: CART.GET_APPLY_OFFER,
        transactionId: CART.GET_TRANSACTION_ID,
        getOptionExceptions: MENU_OPTION_EXCEPTIONS.GET_FOR_ITEM,
        getItemWithId: MENU_ITEMS.GET_ITEM,
        getItemWithParentId: MENU_ITEMS.GET_BY_PARENT_ASSET_ID,
    })),
    methods: __assign({}, mapActions({
        updateItem: CART.UPDATE_ITEM,
        setOffers: ACCOUNT.SET_OFFERS,
        applyOfferAction: ACCOUNT.APPLY_OFFER,
        cancelOfferAction: ACCOUNT.CANCEL_OFFER,
        cartAddItem: CART.ADD_ITEM,
        setCartItems: CART.SET_ITEMS,
        setApplyOffer: CART.SET_APPLY_OFFER,
    }), { 
        // TODO this should check against any applicable item not just all items
        allItemsHaveOffers: function () {
            var cartItems = this.cartItems;
            var itemCount = cartItems.length;
            var discountedItems = filter(cartItems, function (item) {
                return (item.discounts) ? item.quantity <= item.discounts.length : false;
            });
            return (itemCount === discountedItems.length);
        },
        offersForUser: function () {
            var offers = this.getOffers;
            var customer = this.getCustomer;
            offers.forEach(function (offer, index) {
                offer.assignId(customer.id, index);
            });
            return offers;
        },
        getCouponOffers: function () {
            var _this = this;
            var offers = this.getOffers;
            var couponOffers = filter(offers, function (offer) {
                var redeemed = offer.wasRedeemed();
                if (redeemed) {
                    return false;
                }
                var hasCoupon = (!!offer.couponCode);
                var offersInCart = _this.matchingOffersFiltered([offer]);
                var hasItemInCart = (offersInCart.length > 0);
                if (hasItemInCart) {
                    return false;
                }
                // don't show misconfigured ITEM coupons with no items
                var offerHasItems = _this.itemOfferIsValid(offer);
                if (!offerHasItems) {
                    return false;
                }
                return hasCoupon;
            });
            return couponOffers;
        },
        hasCouponOffers: function () {
            var couponOffers = this.getCouponOffers();
            return (couponOffers.length > 0);
        },
        getMatchingItemsFromCart: function (itemId) {
            var items = this.cartItems;
            var itemMatches = filter(items, function (item) {
                if (item.id === itemId) {
                    return true;
                }
                return false;
            });
            return itemMatches;
        },
        offerChoices: function (offerItems) {
            var choices = {};
            forEach(offerItems, function (offerItem) {
                var options = offerItem.options;
                if (options) {
                    var offerItemId = offerItem.asset_id;
                    choices[offerItemId] = options;
                }
            });
            return choices;
        },
        offersOnItems: function (_items, offers) {
            var items = _items || this.cartItems;
            var offerIds = map(offers, 'rewardId');
            var offersOnItems = filter(items, function (item) {
                var discounts = map(item.discounts, 'rewardId');
                var hasOffer = filter(discounts, function (discountId) {
                    if (includes(offerIds, discountId)) {
                        return true;
                    }
                    return false;
                });
                return (hasOffer.length > 0);
            });
            return offersOnItems;
        },
        offerlessItems: function (items, offers) {
            var offerIds = map(offers, 'rewardId');
            var offerlessItems = filter(items, function (item) {
                if (!item.discounts) {
                    return true;
                }
                if (item.quantity <= item.discounts.length) {
                    return false;
                }
                var discountReferencesCount = item.getDiscountReferencesCount();
                if (item.quantity <= discountReferencesCount) {
                    return false;
                }
                var discounts = map(item.discounts, 'rewardId');
                var hasOffer = filter(discounts, function (discountId) {
                    if (includes(offerIds, discountId)) {
                        return true;
                    }
                    return false;
                });
                if (hasOffer.length > 0) {
                    return false;
                }
                return true;
            });
            return offerlessItems;
        },
        matchingOffersFiltered: function (offers, _items) {
            var items = _items || this.cartItems;
            var filtered = true;
            return this.matchingOffers(offers, items, filtered);
        },
        findItemWithOffer: function (items, offer) {
            var _this = this;
            return items.find(function (item) {
                var discountTotal = item.discounts.reduce(function (accum, discount) {
                    var optionExceptions = _this.getOptionExceptions(item.id) || [];
                    return accum + discount.discountPriceForItem(item, optionExceptions);
                }, 0);
                var referenceCount = item.getDiscountReferencesCount();
                if (!discountTotal || !referenceCount) {
                    return false;
                }
                else {
                    return find(item.discounts, { id: offer.id });
                }
            });
        },
        matchingOffers: function (offers, _items, filtered) {
            var _this = this;
            var items = _items || this.cartItems;
            var filteredItems = items;
            if (filtered) {
                filteredItems = this.offerlessItems(items, offers);
            }
            var itemIds = map(filteredItems, 'id');
            var matchingOffers = [];
            forEach(offers, function (offer) {
                var offerItems = offer.items;
                if (!offerItems) {
                    if (!offer.forLineItem) {
                        return;
                    }
                    if (offer.rewardFlags === 2 /* RewardFlagVisits */ && filtered) {
                        // we dont have items for this offer, need to find an item that has this item
                        if (!_this.findItemWithOffer(filteredItems, offer)) {
                            matchingOffers.push(offer);
                        }
                        else {
                            return;
                        }
                    }
                    else {
                        matchingOffers.push(offer);
                    }
                }
                var offerItemIds = map(offerItems, 'asset_id');
                var offerOptionChoices = _this.offerChoices(offerItems);
                var offerItemId = find(itemIds, function (itemId) {
                    var matchedId = includes(offerItemIds, itemId);
                    var offerFlag = false;
                    if (matchedId) {
                        // Look at option choices if there are any
                        var matchingItems_1 = _this.getMatchingItemsFromCart(itemId);
                        var offerRequirements = offerOptionChoices[itemId];
                        if (offerRequirements.length === 0) {
                            offerFlag = true;
                        }
                        forEach(offerRequirements, function (requirement) {
                            var optionId = requirement.option_id;
                            if (optionId.indexOf('f') === -1) {
                                optionId = "f" + requirement.option_id; // hack for working options
                            }
                            var matchingChoices = [];
                            forEach(matchingItems_1, function (matchedItem) {
                                var matchedOptions = matchedItem.options;
                                var filteredOptions = filter(matchedOptions, function (option) {
                                    if (option.id === optionId) {
                                        return true;
                                    }
                                    return false;
                                });
                                forEach(filteredOptions, function (option) {
                                    var choices = map(option.choices, 'id');
                                    matchingChoices.push(choices);
                                });
                            });
                            matchingChoices = flatten(matchingChoices);
                            forEach(requirement.choices, function (choice) {
                                if (includes(matchingChoices, "" + choice)) {
                                    offerFlag = true;
                                }
                            });
                        });
                    }
                    return offerFlag;
                });
                if (offerItemId) {
                    matchingOffers.push(offer);
                }
            });
            return matchingOffers;
        },
        matchingOffersFilteredInCart: function () {
            var offers = this.offersForUser();
            return this.matchingOffersFiltered(offers);
        },
        matchingOffersInCart: function () {
            var offers = this.offersForUser();
            return this.matchingOffers(offers);
        },
        hasOffersInCart: function () {
            var matchingOffers = this.matchingOffersInCart();
            if (!matchingOffers) {
                return false;
            }
            return (matchingOffers.length > 0);
        },
        hasAvailableOfferInCart: function () {
            var customer = this.getCustomer;
            if (customer && customer.id === null) {
                return false;
            }
            var matchingOffers = this.matchingOffersFilteredInCart();
            var validOffers = filter(matchingOffers, function (offer) {
                return offer.isValid();
            });
            if (validOffers.length > 0) {
                return true;
            }
            return false;
        },
        hasOfferInCart: function (offer) {
            var offers = [offer];
            var matches = this.matchingOffersFiltered(offers);
            return (matches.length > 0);
        },
        getAppliedOffers: function () {
            var offers = this.getOffers;
            offers = filter(offers, function (offer) {
                return offer.wasRedeemed();
            });
            var offersInCart = this.matchingOffers(offers);
            return offersInCart;
        },
        getAppliedOfferAmount: function () {
            var _this = this;
            var appliedOffers = this.getAppliedOffers();
            var offerTotal = reduce(appliedOffers, function (accumulator, offer) {
                // TODO allow for offer to effect multiple items
                var cartItem = cartService.convertToCartItem(offer.items[0], _this.menuItems);
                if (!cartItem) {
                    return accumulator;
                }
                var items = _this.getMatchingItemsFromCart(cartItem.id);
                if (items.length === 0) {
                    return accumulator;
                }
                var optionExceptions = _this.getOptionExceptions(items[0].id) || [];
                return accumulator + offer.discountPriceForItem(items[0], optionExceptions);
            }, 0);
            return offerTotal;
        },
        applyOfferItem: function (offer) {
            var _this = this;
            // default loyalty offer
            // online store doesn't support forOrder yet but will
            // if (offer.rewardFlags === 2 && offer.forOrder) {
            // 	this.cartAddItem(new CartItemModel({name: offer.name, discounts: [offer]}));
            // } else {
            var items = this.cartItems;
            var sortItems = cartService.sortMostExpensiveItems(items);
            var itemOffer = find(sortItems, function (item) {
                if (!item.canApplyOffer()) {
                    return false;
                }
                else {
                    var match = _this.matchingOffersFiltered([offer], [item]);
                    return (match.length > 0);
                }
            });
            if (itemOffer) {
                // Add the offer to an item (best match)
                this.applyOfferAction(offer);
                itemOffer.addDiscount(offer);
                // split item in cart
                // TODO (big todo) cartItems is an array. The Cart itself should be a model.
                var allItems = this.allCartItems;
                var splitItems = cartService.splitItemsWithDiscount(allItems);
                var itemIndex = findIndex(splitItems, function (item) {
                    return itemOffer.hash() === item.hash();
                });
                this.updateItem({
                    item: itemOffer,
                    index: itemIndex,
                });
                this.setCartItems(splitItems);
            }
        },
        removeOfferFromItem: function (offer) {
            // Remove the offer from an item
            var items = this.cartItems;
            // filter for items with discounts
            var discountedItems = filter(items, function (item) {
                if (item.discounts) {
                    return (item.discounts.length > 0);
                }
                return false;
            });
            var itemWithOffer = find(discountedItems, function (item) {
                var discounts = map(item.discounts, 'rewardId');
                if (includes(discounts, offer.rewardId)) {
                    return true;
                }
                return false;
            });
            if (!itemWithOffer) {
                return;
            }
            var itemIndex = findIndex(items, function (item) {
                return itemWithOffer.hash() === item.hash();
            });
            itemWithOffer.removeDiscount(offer);
            this.cancelOfferAction(offer);
            this.updateItem({
                item: itemWithOffer,
                index: itemIndex,
            });
            this.setCartItems(this.cartItems);
        },
        getOfferKey: function (offer, index) {
            if (!offer.rewardId) {
                return offer.id + "~" + index;
            }
            else {
                return offer.id;
            }
        },
        persistOffers: function () {
            var _this = this;
            //  loop through available offers and assign to customer depending on whats in cart
            // todo consolidate
            this.cartItems.forEach(function (cartItem) {
                var indexesToRemove = [];
                cartItem.discounts.forEach(function (discount, index) {
                    var offerModel = _this.getOffers.find(function (offer) {
                        // if not loyalty visits, match on rewardId
                        if (offer.rewardId && discount.rewardId && offer.rewardFlags !== 2 /* RewardFlagVisits */) {
                            return offer.rewardId === discount.rewardId;
                        }
                        else if (discount.rewardFlags === 2 /* RewardFlagVisits */ &&
                            discount.name === offer.name) {
                            return true;
                        }
                    });
                    // exists
                    var redemptions = discount.redemptions;
                    if (offerModel) {
                        offerModel.redemptions = redemptions;
                        cartItem.discounts[index] = offerModel;
                        _this.setCartItems(_this.cartItems);
                    }
                    else {
                        // didn't exist, get rid of that discount
                        indexesToRemove.push(index);
                    }
                });
                //  remove these discounts
                indexesToRemove.forEach(function (index) {
                    cartItem.discounts.splice(index, 1);
                });
            });
        },
        getOfferItems: function (offer) {
            var _this = this;
            var offerItems = offer.items;
            if (!offerItems) {
                return [];
            }
            // only add items that are acutally present in items_map
            var items = offerItems.reduce(function (accum, item) {
                var foundItem = _this.getItemWithId(item.asset_id) || _this.getItemWithParentId(item.parent_asset_id);
                if (foundItem) {
                    accum.push(foundItem);
                }
                return accum;
            }, []);
            return items;
        },
        itemOfferIsValid: function (offer) {
            if (offer.rewardFlags === 2 /* RewardFlagVisits */) {
                return true;
            }
            // has an offer type of item and actually has items in our current menu
            return (offer.target === "item" /* ITEM */ && (offer.items === null || offer.items.length === 0 || this.getOfferItems(offer).length));
        } }),
};
export default offersMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/offersMixin.ts
// module id = oUgF
// module chunks = 18